/* eslint-disable */
import React from 'react';
import storage from "utils/Storage";
import { wait, chkd, isMobile, getRandomInt, Event, playAudio } from 'utils/Helper';
import C from 'utils/Constant';
import Canvas from "./components/Canvas";

let loaded = false;

class Game extends React.Component {
    _isMounted = false;
    constructor(props){
        super(props);
        this.state = {
            engine: this.props.engine,
            token: storage.getKey('token'),
            started: false,
            canvas: null
        }
    }

    componentDidMount() {
        this._isMounted = true;
        let { engine } = this.state;
        this.setUpCanvas();

        engine.on(C.PLAY_MINE, () => this.play());
        engine.on(C.CLICKED_MINE, (data) => this.clicked(data));
        engine.on(C.BUSTED_MINE, (data) => this.endGame(data));
        engine.on(C.CASHOUT_MINE, (data) => this.endGame(data));

        if(isMobile()){
            let canvas = document.getElementById('game');
            canvas.style.width = '100%'
            canvas.style.height = '100%'
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if(this.state.canvas !== null)
            this.state.canvas.destroy();
    }

    setUpCanvas(){
        if(this._isMounted){
            let canvas = new Canvas()
            this.setState({ canvas: canvas })
            canvas.init(this.select);
        }
    }

    select = (id) => {
        let { engine, started } = this.state;
        if(started)
        {
            engine.init = true;
            engine.land = id;
            engine.clicked();
        }
    };

    play = () => {
        if(this._isMounted){
            this.state.canvas.play();
            this.setState({ started: true });
        }
    };

    clicked(data){
        if(this._isMounted){
            let { id } = data;
            this.state.canvas.afterSelect(id);
            playAudio('win.mp3');
        }
    }

    endGame(data){
        if(this._isMounted){
            let { mines } = data;
            
            this.state.canvas.busted(mines);

            this.setState({ started: false });

            wait(2200).then(() => {
                if(this.state.canvas !== null)
                    this.state.canvas.reset();
            })
        }
    }

    render() {
        return(
            <div className="_mine_container animated fadeIn" >
                <div className="_cf_info _cf_info_m" >
                    {/* <div className="text-center" id="cc">
                        <div style={{marginTop:"4%",width:"auto",textAlign:"right", marginBottom:"30px"}}>
                            <img src='assets/images/box-bg2.webp' alt='img'style={{width:"20%",top:"20px",marginRight:"20%"}} />
                        </div>
                        <canvas id="game" style={{border:"8px solid #0b0c0d" , marginTop:"-5%",marginBottom:"2%",backgroundColor:"#0b0c0d", width:"60%",padding:"7px" }} />
                    </div> */}

{/* <div className="text-center" id="cc" style={{ position: 'relative', width: '100%' }}>
  <div style={{
    position: 'absolute',
    top: '3.7%',
    right: '25%',
    zIndex: '10',
    width: '20%',
    marginBottom: '30px',
    textAlign: 'right'
  }}>

    <img
      src="assets/images/box-bg2.webp"
      alt="img"
      style={{
        width: '100%', // Make the image responsive
        maxWidth: '200px', // Maximum width for the image
        objectFit: 'contain' // Ensures the image maintains its aspect ratio
      }}
    />
  </div>
  <canvas
    id="game"
    style={{
      border: '8px solid #0b0c0d',
      marginTop: '7%',
      marginBottom: '2%',
      backgroundColor: '#0b0c0d',
      width: '60%',
    //   maxWidth: '800px', // Optional: limit the canvas size on large screens
      padding: '7px',
      zIndex: '1', // Ensure canvas is behind the image
      position: 'relative' // Ensures canvas is positioned relative to the parent div
    }}
  />
</div> */}

<div className="text-center" id="cc" style={{ position: 'relative', width: '100%' }}>
  
  {/* box-bg3 Image on the Left */}
  <div style={{
    position: 'absolute',
    top: '8.6%',           // Adjust the top to position it vertically
    left: '20%',          // Position it on the left side of the screen (relative to canvas)
    zIndex: '10',        // Ensure it is above the canvas
    width: '20%',
    marginBottom: '30px',
    textAlign: 'left',
    
  }}>
    {/* <img src='/assets/images/box-bg3.png'
         style={{
           width: '50%',       // Make the image responsive
           maxWidth: '100px',  // Maximum width of the image
           objectFit: 'contain' // Ensures the image keeps its aspect ratio
         }}
    /> */}
  </div>
  
  {/* box-bg2 Image on the Right */}
  <div style={{
    position: 'absolute',
    top: '4.2%',          // Position the second image on the right
    right: '19%',         // Position it on the right side of the canvas (relative to canvas)
    zIndex: '10',         // Ensure it is above the canvas
    width: '19.2%',
    marginBottom: '30px',
    textAlign: 'right',
    
  }}>
    <img src="assets/images/box-bg2.webp"
         alt="img"
         style={{
           width: '100%',     // Make the image responsive
           maxWidth: '250px', // Maximum width of the image
           objectFit: 'contain' // Ensures the image maintains its aspect ratio
         }}
    />
  </div>
  
  {/* Canvas */}
  <canvas
    id="game"
    style={{
      border: '2px solid #0b0c0d',
      marginTop: '7%',
      // marginBottom: '2%',
      backgroundColor: '#0b0c0d',
      width: '60%',
      padding: '12px 7px 7px 12px',
      zIndex: '1',         // Ensure canvas is behind the images
      position: 'relative' // Ensures canvas is positioned relative to the parent div
    }}
  />
</div>


                </div>
            </div>
        );
    }
}

export default Game;
